jQuery(function ($) {
    // Smooth scroll for anchor links
    $('a[href*="#"]:not([href="#"])').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
            location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html, body').animate({ scrollTop: target.offset().top - 125 }, 0);
                return false;
            }
        }
    });
});

// konami code
const codes = [
  "ArrowUp", "ArrowUp", "ArrowDown", "ArrowDown", "ArrowLeft", "ArrowRight", "ArrowLeft", "ArrowRight", "b", "a"
];

let index = 0;

document.addEventListener("keydown", (e) => {
  const key = e.key;

  if(key === codes[index]){
    index++;

    if (index === codes.length){
      alert('Schedule a free consultation and mention the KONAMI CODE for 5% off digital creative services.');

      index = 0;
    }
  } else {
    index = 0;
  }
});

// restore browser element scroll position
const boxes = document.querySelectorAll('.browser__screen');

window.addEventListener('pageshow', () => {
  requestAnimationFrame(() => {
    boxes.forEach(el => { el.scrollTop = 0; });
  });
});

// lake merritt lights illumination
const scene = document.querySelector('.lakeshore__lights');

if (scene) {
	const io = new IntersectionObserver((entries) => {
		for (const entry of entries) {
			if (!entry.isIntersecting) continue;

			entry.target.classList.add('is-lit');
			setTimeout(() => entry.target.classList.add('is-settled'), 1900);

			io.unobserve(entry.target);
		}
	}, {
		threshold: 0.4,
		rootMargin: '0px 0px -8% 0px'
	});
	io.observe(scene);
}